import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LocalStorageService } from '../../core/local-storage.service';
import { KEY_CODE, LinkEnum, RoleEnum, UserRole } from '../../shared/enum/base.enum';
import { LanguageTranslatorComponent } from '../../shared/language-convertor/language-translator.component';
import { LoaderService } from '../../shared/services/loader.service';
import { NewPasswordModel } from './shared/forgot-password.model';
import { ForgotPasswordService } from './shared/forgot-password.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends LanguageTranslatorComponent implements OnInit {
  showIcon: string;
  isFieldRequired: boolean = true;
  showPasswordIcon: string;
  newPasswordModel: NewPasswordModel = new NewPasswordModel();
  resendOtp: boolean;
  userRole = UserRole;
  @ViewChild('password', { static: false }) password: ElementRef;
  @ViewChild('confirm_password', { static: false }) confirmPassword: ElementRef;
  constructor(public localStorageService: LocalStorageService, private router: Router, private route: ActivatedRoute, private toastr: ToastrManager, private forgotPasswordService: ForgotPasswordService, private loaderService: LoaderService) {
    super(localStorageService);

  }

  ngOnInit() {
    this.route.queryParams.subscribe((res) => {
      this.languageCode = res.languageCode;
    });
    this.showIcon = 'fa fa-eye';
    this.showPasswordIcon = 'fa fa-eye';
  }

  navToLogin() {
    this.router.navigate(['login']);
  }

  showHidePassword() {
    let x: any;
    x = this.password.nativeElement;
    if (x.type === "password") {
      x.type = "text";
      this.showIcon = 'fa fa-eye-slash';
    } else {
      x.type = "password";
      this.showIcon = 'fa fa-eye';

    }
  }


  showHideConfirmPassword() {
    let x: any;
    x = this.confirmPassword.nativeElement;
    if (x.type === "password") {
      x.type = "text";
      this.showPasswordIcon = 'fa fa-eye-slash';
    } else {
      x.type = "password";
      this.showPasswordIcon = 'fa fa-eye';

    }
  }

  onSubmit(value) {
    if (!value) {
      this.showIcon = 'fa fa-eye';
      this.showPasswordIcon = 'fa fa-eye';
    }

    this.isFieldRequired = true;
    if (this.newPasswordModel.userName) {
      const formData = new FormData();
      formData.append('linkTableCD', LinkEnum.ADMIN);
      formData.append('secureActionTypeCD', LinkEnum.FORGOT_PASSWORD);
      formData.append('username', this.newPasswordModel.userName);
      formData.append('languageCode', this.languageCode);
      this.loaderService.showLoader();
      this.forgotPasswordService.checkValidUser(formData).subscribe((res: any) => {
        if (res) {
          this.loaderService.hideLoader();
          const msg = this.localStorageService.getSelectedLanguageValue('General.OTPsentsuccessfully');
          this.toastr.successToastr(msg);
          if (!value) {
            this.newPasswordModel.newPassword = '';
            this.newPasswordModel.confirmPassword = '';
            this.newPasswordModel.otp = '';
            this.newPasswordModel.otpUId = res.uId;
          }
          this.newPasswordModel.display = true;
          this.newPasswordModel.header = this.localStorageService.getSelectedLanguageValue('General.CreateNewPassword');

        } else {
          const errorMessage = this.localStorageService.getSelectedLanguageValue('General.UserNotFound');
          this.toastr.errorToastr(errorMessage);
          this.loaderService.hideLoader();

        }
      }, (err) => {
        this.loaderService.hideLoader();
      });
    } else {
      this.isFieldRequired = false;
    }


  }

  _Keydown(event) {
    if (event.target.value.length < 1) {
      if (event.keyCode === KEY_CODE.Space_Tab) {
        event.preventDefault();
      }
    }
  }

  updatePassword(value) {
    this.isFieldRequired = true;
    if (value) {
      this.newPasswordModel.roleId = RoleEnum.Admin;
      const formData = new FormData();
      formData.append('otp_uid', this.newPasswordModel.otpUId);
      formData.append('email_otp', this.newPasswordModel.otp);
      formData.append('new_password', this.newPasswordModel.newPassword);
      formData.append('secureActionTypeCD', LinkEnum.FORGOT_PASSWORD);
      this.loaderService.showLoader();
      this.forgotPasswordService.updatePassword(formData).subscribe((res: any) => {
        if (res) {
          this.loaderService.hideLoader();
          this.newPasswordModel.display = false;
          const msg = this.localStorageService.getSelectedLanguageValue('General.Passwordchangedsuccessfully');
          this.toastr.successToastr(msg);
          this.router.navigate(['login'], { queryParams: { languageCode: this.newPasswordModel.languageCode } });
        }
      }, (err) => {
        this.loaderService.hideLoader();

      });
    } else {
      this.isFieldRequired = false;

    }
  }

}
